export default {
  border: 'StrokeColor',
  fill: 'FillColor',
  text: 'TextColor',
};